/**
 * Parses common backend timestamp shapes and formats them in the user's local timezone.
 * Naive "YYYY-MM-DD HH:mm:ss" is treated as UTC when no timezone suffix is present.
 */
export function formatBackendDateTimeLocal(dateTimeStr: string): string {
  if (!dateTimeStr || !String(dateTimeStr).trim()) return '-';

  try {
    let s = String(dateTimeStr).trim();

    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(s)) {
      s = s.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})/, '$1T$2');
    }

    const timeMatch = s.match(/^(.*T\d{2}:\d{2}:\d{2})(\.\d+)?(.*)$/);
    if (timeMatch) {
      const head = timeMatch[1];
      let frac = timeMatch[2] || '';
      const tail = timeMatch[3] || '';
      if (frac && frac.length > 4) {
        frac = frac.slice(0, 4);
      }
      s = `${head}${frac}${tail}`;
    }

    const hasTZ = /(?:[zZ]|[+-]\d{2}(?::?\d{2})?)$/.test(s);
    if (!hasTZ) {
      s = `${s}Z`;
    }

    const date = new Date(s);
    if (isNaN(date.getTime())) return '-';

    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date);
  } catch {
    return '-';
  }
}
